import CoreBase from '../../../../../services/engines/CoreBase';
import iframeController from '../IframeController';
import entryUpdater from '../EntryUpdater';

class UpdateMealHandler extends CoreBase {
    _name = 'UpdateMealHandler';

    /**
     * Handles jerny:updatemeal — replaces items array on a meal or action entry by ems and persists.
     * @param {MessageEvent} e
     * @param {HTMLIFrameElement} iframe
     * @param {object} entry
     */
    handle = (e, iframe, entry) => {
        try {
            if (e.source !== iframe?.contentWindow) return;

            const { ems, items } = e.data ?? {};
            if (!ems || !Array.isArray(items)) return;

            const body = iframeController.parseBody(entry);
            if (!body) return;

            const item = body.userInput?.find(i => i.ems === ems);
            if (!item || (item.type !== 'meal' && item.type !== 'action')) return;

            item.items = items;

            entryUpdater.update(entry, body);
        } catch (error) {
            this.logError('handle', error.message);
        }
    };
}

const updateMealHandler = new UpdateMealHandler();
export default updateMealHandler;
